import axiosIns from "@/api/axios";

export const GET_LIST_COMPARE = (args) => {
  return axiosIns.post("/compare-actual", args);
};
